import { applyPhoneNumberMask } from "@plasma/utils/phone-numbers";
import { useNavigate } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

const BusinessInformationTitle = {
  businessName: "Business Name",
  phoneNumber: "Phone Number",
} as const;

interface BusinessInformation {
  businessName?: string;
  businessEmail?: string;
  phoneNumber?: string;
  onboardingComplete: boolean;
  useStripeAccountsV2?: boolean;
  stripeAccountId?: string;
}

interface BusinessInformationCardProps {
  businessData: BusinessInformation | null;
  type: "businessName" | "phoneNumber";
}

// V4.1: Simplified component - edit functionality moved to route-based modal
export function BusinessInformationCard({
  businessData,
  type,
}: BusinessInformationCardProps) {
  const navigate = useNavigate();
  // Convert type to id, e.g. "businessName" to "business-name"
  const id = type.replace(/([A-Z])/g, "-$1").toLowerCase();

  // V4.1: Navigate to route-based edit modal for URL context tracking
  const handleEdit = () => {
    void navigate({ to: `/settings/business-information/edit/${type}` });
  };

  return (
    <button
      className="border-border bg-background hover:border-border inline-flex h-16 w-full max-w-4xl cursor-pointer items-center justify-start gap-2 rounded-xl border px-5 py-4"
      id={id}
      onClick={handleEdit}
      type="button"
    >
      <p className="label text-foreground min-w-40 leading-tight">
        {BusinessInformationTitle[type]}
      </p>
      <p className="body-sm text-foreground shrink grow basis-0 leading-tight">
        {(() => {
          if (type === "phoneNumber") {
            return businessData?.phoneNumber
              ? applyPhoneNumberMask(businessData.phoneNumber)
              : "";
          }
          return businessData?.businessName;
        })()}
      </p>
      <div className="flex h-9 w-9 items-center justify-center">
        <ChevronRight className="text-foreground size-5" />
      </div>
    </button>
  );
}
